import { render, staticRenderFns } from "./fisfisa.vue?vue&type=template&id=973d06d2&scoped=true&"
import script from "./fisfisa.vue?vue&type=script&lang=js&"
export * from "./fisfisa.vue?vue&type=script&lang=js&"
import style0 from "./fisfisa.vue?vue&type=style&index=0&id=973d06d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973d06d2",
  null
  
)

export default component.exports